import script from "./SelectableSimpleTableContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectableSimpleTableContent.vue?vue&type=script&lang=ts&setup=true"

import "./SelectableSimpleTableContent.vue?vue&type=style&index=0&id=1ffcf9f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffcf9f3"]])

export default __exports__